/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as TermosDeUsoRouteImport } from './app/routes/termos-de-uso'
import { Route as PoliticaDePrivacidadeRouteImport } from './app/routes/politica-de-privacidade'
import { Route as ManutencaoRouteImport } from './app/routes/manutencao'
import { Route as SplatRouteImport } from './app/routes/$'
import { Route as AuthenticatedRouteRouteImport } from './app/routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './app/routes/_auth/route'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as AuthSignUpRouteImport } from './app/routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './app/routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './app/routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './app/routes/_auth/reset-password'
import { Route as AuthResendConfirmationRouteImport } from './app/routes/_auth/resend-confirmation'
import { Route as AuthRefreshSessionRouteImport } from './app/routes/_auth/refresh-session'
import { Route as AuthForgotPasswordRouteImport } from './app/routes/_auth/forgot-password'
import { Route as AuthConfirmationRouteImport } from './app/routes/_auth/confirmation'
import { Route as AuthAcceptInviteRouteImport } from './app/routes/_auth/accept-invite'
import { Route as AuthenticatedMainRouteRouteImport } from './app/routes/_authenticated/_main/route'
import { Route as AuthenticatedNiveisLevelUidRouteImport } from './app/routes/_authenticated/niveis/$levelUid'
import { Route as AuthenticatedMainRankingRouteImport } from './app/routes/_authenticated/_main/ranking'
import { Route as AuthenticatedMainMissoesRouteImport } from './app/routes/_authenticated/_main/missoes'
import { Route as AuthenticatedMainMaisRouteImport } from './app/routes/_authenticated/_main/mais'
import { Route as AuthenticatedMainJornadasRouteImport } from './app/routes/_authenticated/_main/jornadas'
import { Route as AuthenticatedMainTitulosIndexRouteImport } from './app/routes/_authenticated/_main/titulos/index'
import { Route as AuthenticatedMainQuizzesIndexRouteImport } from './app/routes/_authenticated/_main/quizzes/index'
import { Route as AuthenticatedMainPasseIndexRouteImport } from './app/routes/_authenticated/_main/passe/index'
import { Route as AuthenticatedMainNovidadesIndexRouteImport } from './app/routes/_authenticated/_main/novidades/index'
import { Route as AuthenticatedMainMeusDadosIndexRouteImport } from './app/routes/_authenticated/_main/meus-dados/index'
import { Route as AuthenticatedMainLojaIndexRouteImport } from './app/routes/_authenticated/_main/loja/index'
import { Route as AuthenticatedMainGruposIndexRouteImport } from './app/routes/_authenticated/_main/grupos/index'
import { Route as AuthenticatedMainCentralDeAjudaIndexRouteImport } from './app/routes/_authenticated/_main/central-de-ajuda/index'
import { Route as AuthenticatedMainCampanhasIndexRouteImport } from './app/routes/_authenticated/_main/campanhas/index'
import { Route as AuthenticatedMainBibliotecaIndexRouteImport } from './app/routes/_authenticated/_main/biblioteca/index'
import { Route as AuthenticatedMainAvaliacoesIndexRouteImport } from './app/routes/_authenticated/_main/avaliacoes/index'
import { Route as AuthenticatedMainAmigosIndexRouteImport } from './app/routes/_authenticated/_main/amigos/index'
import { Route as AuthenticatedMainQuizzesQuizIdRouteImport } from './app/routes/_authenticated/_main/quizzes/$quizId'
import { Route as AuthenticatedMainLojaHistoricoRouteImport } from './app/routes/_authenticated/_main/loja/historico'
import { Route as AuthenticatedMainGruposEntrarRouteImport } from './app/routes/_authenticated/_main/grupos/entrar'
import { Route as AuthenticatedMainDevBotoesRouteImport } from './app/routes/_authenticated/_main/dev/botoes'
import { Route as AuthenticatedMainCampanhasIngressoRouteImport } from './app/routes/_authenticated/_main/campanhas/ingresso'
import { Route as AuthenticatedMainCampanhasCampaignIdRouteImport } from './app/routes/_authenticated/_main/campanhas/$campaignId'
import { Route as AuthenticatedMainAvaliacoesEvaluationIdRouteImport } from './app/routes/_authenticated/_main/avaliacoes/$evaluationId'
import { Route as AuthenticatedMainLojaCategoriasCategoryIdRouteImport } from './app/routes/_authenticated/_main/loja/categorias/$categoryId'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
  id: '/termos-de-uso',
  path: '/termos-de-uso',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
  id: '/politica-de-privacidade',
  path: '/politica-de-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const ManutencaoRoute = ManutencaoRouteImport.update({
  id: '/manutencao',
  path: '/manutencao',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignOutRoute = AuthSignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResendConfirmationRoute = AuthResendConfirmationRouteImport.update({
  id: '/resend-confirmation',
  path: '/resend-confirmation',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRefreshSessionRoute = AuthRefreshSessionRouteImport.update({
  id: '/refresh-session',
  path: '/refresh-session',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthConfirmationRoute = AuthConfirmationRouteImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedMainRouteRoute = AuthenticatedMainRouteRouteImport.update({
  id: '/_main',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedNiveisLevelUidRoute =
  AuthenticatedNiveisLevelUidRouteImport.update({
    id: '/niveis/$levelUid',
    path: '/niveis/$levelUid',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMainRankingRoute =
  AuthenticatedMainRankingRouteImport.update({
    id: '/ranking',
    path: '/ranking',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainMissoesRoute =
  AuthenticatedMainMissoesRouteImport.update({
    id: '/missoes',
    path: '/missoes',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainMaisRoute = AuthenticatedMainMaisRouteImport.update({
  id: '/mais',
  path: '/mais',
  getParentRoute: () => AuthenticatedMainRouteRoute,
} as any)
const AuthenticatedMainJornadasRoute =
  AuthenticatedMainJornadasRouteImport.update({
    id: '/jornadas',
    path: '/jornadas',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainTitulosIndexRoute =
  AuthenticatedMainTitulosIndexRouteImport.update({
    id: '/titulos/',
    path: '/titulos/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainQuizzesIndexRoute =
  AuthenticatedMainQuizzesIndexRouteImport.update({
    id: '/quizzes/',
    path: '/quizzes/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainPasseIndexRoute =
  AuthenticatedMainPasseIndexRouteImport.update({
    id: '/passe/',
    path: '/passe/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainNovidadesIndexRoute =
  AuthenticatedMainNovidadesIndexRouteImport.update({
    id: '/novidades/',
    path: '/novidades/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainMeusDadosIndexRoute =
  AuthenticatedMainMeusDadosIndexRouteImport.update({
    id: '/meus-dados/',
    path: '/meus-dados/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainLojaIndexRoute =
  AuthenticatedMainLojaIndexRouteImport.update({
    id: '/loja/',
    path: '/loja/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainGruposIndexRoute =
  AuthenticatedMainGruposIndexRouteImport.update({
    id: '/grupos/',
    path: '/grupos/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainCentralDeAjudaIndexRoute =
  AuthenticatedMainCentralDeAjudaIndexRouteImport.update({
    id: '/central-de-ajuda/',
    path: '/central-de-ajuda/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainCampanhasIndexRoute =
  AuthenticatedMainCampanhasIndexRouteImport.update({
    id: '/campanhas/',
    path: '/campanhas/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainBibliotecaIndexRoute =
  AuthenticatedMainBibliotecaIndexRouteImport.update({
    id: '/biblioteca/',
    path: '/biblioteca/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainAvaliacoesIndexRoute =
  AuthenticatedMainAvaliacoesIndexRouteImport.update({
    id: '/avaliacoes/',
    path: '/avaliacoes/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainAmigosIndexRoute =
  AuthenticatedMainAmigosIndexRouteImport.update({
    id: '/amigos/',
    path: '/amigos/',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainQuizzesQuizIdRoute =
  AuthenticatedMainQuizzesQuizIdRouteImport.update({
    id: '/quizzes/$quizId',
    path: '/quizzes/$quizId',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainLojaHistoricoRoute =
  AuthenticatedMainLojaHistoricoRouteImport.update({
    id: '/loja/historico',
    path: '/loja/historico',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainGruposEntrarRoute =
  AuthenticatedMainGruposEntrarRouteImport.update({
    id: '/grupos/entrar',
    path: '/grupos/entrar',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainDevBotoesRoute =
  AuthenticatedMainDevBotoesRouteImport.update({
    id: '/dev/botoes',
    path: '/dev/botoes',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainCampanhasIngressoRoute =
  AuthenticatedMainCampanhasIngressoRouteImport.update({
    id: '/campanhas/ingresso',
    path: '/campanhas/ingresso',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainCampanhasCampaignIdRoute =
  AuthenticatedMainCampanhasCampaignIdRouteImport.update({
    id: '/campanhas/$campaignId',
    path: '/campanhas/$campaignId',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainAvaliacoesEvaluationIdRoute =
  AuthenticatedMainAvaliacoesEvaluationIdRouteImport.update({
    id: '/avaliacoes/$evaluationId',
    path: '/avaliacoes/$evaluationId',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)
const AuthenticatedMainLojaCategoriasCategoryIdRoute =
  AuthenticatedMainLojaCategoriasCategoryIdRouteImport.update({
    id: '/loja/categorias/$categoryId',
    path: '/loja/categorias/$categoryId',
    getParentRoute: () => AuthenticatedMainRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/manutencao': typeof ManutencaoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/confirmation': typeof AuthConfirmationRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/refresh-session': typeof AuthRefreshSessionRoute
  '/resend-confirmation': typeof AuthResendConfirmationRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/jornadas': typeof AuthenticatedMainJornadasRoute
  '/mais': typeof AuthenticatedMainMaisRoute
  '/missoes': typeof AuthenticatedMainMissoesRoute
  '/ranking': typeof AuthenticatedMainRankingRoute
  '/niveis/$levelUid': typeof AuthenticatedNiveisLevelUidRoute
  '/avaliacoes/$evaluationId': typeof AuthenticatedMainAvaliacoesEvaluationIdRoute
  '/campanhas/$campaignId': typeof AuthenticatedMainCampanhasCampaignIdRoute
  '/campanhas/ingresso': typeof AuthenticatedMainCampanhasIngressoRoute
  '/dev/botoes': typeof AuthenticatedMainDevBotoesRoute
  '/grupos/entrar': typeof AuthenticatedMainGruposEntrarRoute
  '/loja/historico': typeof AuthenticatedMainLojaHistoricoRoute
  '/quizzes/$quizId': typeof AuthenticatedMainQuizzesQuizIdRoute
  '/amigos/': typeof AuthenticatedMainAmigosIndexRoute
  '/avaliacoes/': typeof AuthenticatedMainAvaliacoesIndexRoute
  '/biblioteca/': typeof AuthenticatedMainBibliotecaIndexRoute
  '/campanhas/': typeof AuthenticatedMainCampanhasIndexRoute
  '/central-de-ajuda/': typeof AuthenticatedMainCentralDeAjudaIndexRoute
  '/grupos/': typeof AuthenticatedMainGruposIndexRoute
  '/loja/': typeof AuthenticatedMainLojaIndexRoute
  '/meus-dados/': typeof AuthenticatedMainMeusDadosIndexRoute
  '/novidades/': typeof AuthenticatedMainNovidadesIndexRoute
  '/passe/': typeof AuthenticatedMainPasseIndexRoute
  '/quizzes/': typeof AuthenticatedMainQuizzesIndexRoute
  '/titulos/': typeof AuthenticatedMainTitulosIndexRoute
  '/loja/categorias/$categoryId': typeof AuthenticatedMainLojaCategoriasCategoryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/manutencao': typeof ManutencaoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/confirmation': typeof AuthConfirmationRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/refresh-session': typeof AuthRefreshSessionRoute
  '/resend-confirmation': typeof AuthResendConfirmationRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/jornadas': typeof AuthenticatedMainJornadasRoute
  '/mais': typeof AuthenticatedMainMaisRoute
  '/missoes': typeof AuthenticatedMainMissoesRoute
  '/ranking': typeof AuthenticatedMainRankingRoute
  '/niveis/$levelUid': typeof AuthenticatedNiveisLevelUidRoute
  '/avaliacoes/$evaluationId': typeof AuthenticatedMainAvaliacoesEvaluationIdRoute
  '/campanhas/$campaignId': typeof AuthenticatedMainCampanhasCampaignIdRoute
  '/campanhas/ingresso': typeof AuthenticatedMainCampanhasIngressoRoute
  '/dev/botoes': typeof AuthenticatedMainDevBotoesRoute
  '/grupos/entrar': typeof AuthenticatedMainGruposEntrarRoute
  '/loja/historico': typeof AuthenticatedMainLojaHistoricoRoute
  '/quizzes/$quizId': typeof AuthenticatedMainQuizzesQuizIdRoute
  '/amigos': typeof AuthenticatedMainAmigosIndexRoute
  '/avaliacoes': typeof AuthenticatedMainAvaliacoesIndexRoute
  '/biblioteca': typeof AuthenticatedMainBibliotecaIndexRoute
  '/campanhas': typeof AuthenticatedMainCampanhasIndexRoute
  '/central-de-ajuda': typeof AuthenticatedMainCentralDeAjudaIndexRoute
  '/grupos': typeof AuthenticatedMainGruposIndexRoute
  '/loja': typeof AuthenticatedMainLojaIndexRoute
  '/meus-dados': typeof AuthenticatedMainMeusDadosIndexRoute
  '/novidades': typeof AuthenticatedMainNovidadesIndexRoute
  '/passe': typeof AuthenticatedMainPasseIndexRoute
  '/quizzes': typeof AuthenticatedMainQuizzesIndexRoute
  '/titulos': typeof AuthenticatedMainTitulosIndexRoute
  '/loja/categorias/$categoryId': typeof AuthenticatedMainLojaCategoriasCategoryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/manutencao': typeof ManutencaoRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/_authenticated/_main': typeof AuthenticatedMainRouteRouteWithChildren
  '/_auth/accept-invite': typeof AuthAcceptInviteRoute
  '/_auth/confirmation': typeof AuthConfirmationRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/refresh-session': typeof AuthRefreshSessionRoute
  '/_auth/resend-confirmation': typeof AuthResendConfirmationRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-out': typeof AuthSignOutRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_authenticated/_main/jornadas': typeof AuthenticatedMainJornadasRoute
  '/_authenticated/_main/mais': typeof AuthenticatedMainMaisRoute
  '/_authenticated/_main/missoes': typeof AuthenticatedMainMissoesRoute
  '/_authenticated/_main/ranking': typeof AuthenticatedMainRankingRoute
  '/_authenticated/niveis/$levelUid': typeof AuthenticatedNiveisLevelUidRoute
  '/_authenticated/_main/avaliacoes/$evaluationId': typeof AuthenticatedMainAvaliacoesEvaluationIdRoute
  '/_authenticated/_main/campanhas/$campaignId': typeof AuthenticatedMainCampanhasCampaignIdRoute
  '/_authenticated/_main/campanhas/ingresso': typeof AuthenticatedMainCampanhasIngressoRoute
  '/_authenticated/_main/dev/botoes': typeof AuthenticatedMainDevBotoesRoute
  '/_authenticated/_main/grupos/entrar': typeof AuthenticatedMainGruposEntrarRoute
  '/_authenticated/_main/loja/historico': typeof AuthenticatedMainLojaHistoricoRoute
  '/_authenticated/_main/quizzes/$quizId': typeof AuthenticatedMainQuizzesQuizIdRoute
  '/_authenticated/_main/amigos/': typeof AuthenticatedMainAmigosIndexRoute
  '/_authenticated/_main/avaliacoes/': typeof AuthenticatedMainAvaliacoesIndexRoute
  '/_authenticated/_main/biblioteca/': typeof AuthenticatedMainBibliotecaIndexRoute
  '/_authenticated/_main/campanhas/': typeof AuthenticatedMainCampanhasIndexRoute
  '/_authenticated/_main/central-de-ajuda/': typeof AuthenticatedMainCentralDeAjudaIndexRoute
  '/_authenticated/_main/grupos/': typeof AuthenticatedMainGruposIndexRoute
  '/_authenticated/_main/loja/': typeof AuthenticatedMainLojaIndexRoute
  '/_authenticated/_main/meus-dados/': typeof AuthenticatedMainMeusDadosIndexRoute
  '/_authenticated/_main/novidades/': typeof AuthenticatedMainNovidadesIndexRoute
  '/_authenticated/_main/passe/': typeof AuthenticatedMainPasseIndexRoute
  '/_authenticated/_main/quizzes/': typeof AuthenticatedMainQuizzesIndexRoute
  '/_authenticated/_main/titulos/': typeof AuthenticatedMainTitulosIndexRoute
  '/_authenticated/_main/loja/categorias/$categoryId': typeof AuthenticatedMainLojaCategoriasCategoryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/manutencao'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/accept-invite'
    | '/confirmation'
    | '/forgot-password'
    | '/refresh-session'
    | '/resend-confirmation'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/jornadas'
    | '/mais'
    | '/missoes'
    | '/ranking'
    | '/niveis/$levelUid'
    | '/avaliacoes/$evaluationId'
    | '/campanhas/$campaignId'
    | '/campanhas/ingresso'
    | '/dev/botoes'
    | '/grupos/entrar'
    | '/loja/historico'
    | '/quizzes/$quizId'
    | '/amigos/'
    | '/avaliacoes/'
    | '/biblioteca/'
    | '/campanhas/'
    | '/central-de-ajuda/'
    | '/grupos/'
    | '/loja/'
    | '/meus-dados/'
    | '/novidades/'
    | '/passe/'
    | '/quizzes/'
    | '/titulos/'
    | '/loja/categorias/$categoryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/manutencao'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/accept-invite'
    | '/confirmation'
    | '/forgot-password'
    | '/refresh-session'
    | '/resend-confirmation'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/jornadas'
    | '/mais'
    | '/missoes'
    | '/ranking'
    | '/niveis/$levelUid'
    | '/avaliacoes/$evaluationId'
    | '/campanhas/$campaignId'
    | '/campanhas/ingresso'
    | '/dev/botoes'
    | '/grupos/entrar'
    | '/loja/historico'
    | '/quizzes/$quizId'
    | '/amigos'
    | '/avaliacoes'
    | '/biblioteca'
    | '/campanhas'
    | '/central-de-ajuda'
    | '/grupos'
    | '/loja'
    | '/meus-dados'
    | '/novidades'
    | '/passe'
    | '/quizzes'
    | '/titulos'
    | '/loja/categorias/$categoryId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/$'
    | '/manutencao'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/_authenticated/_main'
    | '/_auth/accept-invite'
    | '/_auth/confirmation'
    | '/_auth/forgot-password'
    | '/_auth/refresh-session'
    | '/_auth/resend-confirmation'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-out'
    | '/_auth/sign-up'
    | '/_authenticated/_main/jornadas'
    | '/_authenticated/_main/mais'
    | '/_authenticated/_main/missoes'
    | '/_authenticated/_main/ranking'
    | '/_authenticated/niveis/$levelUid'
    | '/_authenticated/_main/avaliacoes/$evaluationId'
    | '/_authenticated/_main/campanhas/$campaignId'
    | '/_authenticated/_main/campanhas/ingresso'
    | '/_authenticated/_main/dev/botoes'
    | '/_authenticated/_main/grupos/entrar'
    | '/_authenticated/_main/loja/historico'
    | '/_authenticated/_main/quizzes/$quizId'
    | '/_authenticated/_main/amigos/'
    | '/_authenticated/_main/avaliacoes/'
    | '/_authenticated/_main/biblioteca/'
    | '/_authenticated/_main/campanhas/'
    | '/_authenticated/_main/central-de-ajuda/'
    | '/_authenticated/_main/grupos/'
    | '/_authenticated/_main/loja/'
    | '/_authenticated/_main/meus-dados/'
    | '/_authenticated/_main/novidades/'
    | '/_authenticated/_main/passe/'
    | '/_authenticated/_main/quizzes/'
    | '/_authenticated/_main/titulos/'
    | '/_authenticated/_main/loja/categorias/$categoryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  ManutencaoRoute: typeof ManutencaoRoute
  PoliticaDePrivacidadeRoute: typeof PoliticaDePrivacidadeRoute
  TermosDeUsoRoute: typeof TermosDeUsoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos-de-uso': {
      id: '/termos-de-uso'
      path: '/termos-de-uso'
      fullPath: '/termos-de-uso'
      preLoaderRoute: typeof TermosDeUsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-de-privacidade': {
      id: '/politica-de-privacidade'
      path: '/politica-de-privacidade'
      fullPath: '/politica-de-privacidade'
      preLoaderRoute: typeof PoliticaDePrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manutencao': {
      id: '/manutencao'
      path: '/manutencao'
      fullPath: '/manutencao'
      preLoaderRoute: typeof ManutencaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-out': {
      id: '/_auth/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof AuthSignOutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/resend-confirmation': {
      id: '/_auth/resend-confirmation'
      path: '/resend-confirmation'
      fullPath: '/resend-confirmation'
      preLoaderRoute: typeof AuthResendConfirmationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/refresh-session': {
      id: '/_auth/refresh-session'
      path: '/refresh-session'
      fullPath: '/refresh-session'
      preLoaderRoute: typeof AuthRefreshSessionRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/confirmation': {
      id: '/_auth/confirmation'
      path: '/confirmation'
      fullPath: '/confirmation'
      preLoaderRoute: typeof AuthConfirmationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/accept-invite': {
      id: '/_auth/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/_main': {
      id: '/_authenticated/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedMainRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/niveis/$levelUid': {
      id: '/_authenticated/niveis/$levelUid'
      path: '/niveis/$levelUid'
      fullPath: '/niveis/$levelUid'
      preLoaderRoute: typeof AuthenticatedNiveisLevelUidRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_main/ranking': {
      id: '/_authenticated/_main/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof AuthenticatedMainRankingRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/missoes': {
      id: '/_authenticated/_main/missoes'
      path: '/missoes'
      fullPath: '/missoes'
      preLoaderRoute: typeof AuthenticatedMainMissoesRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/mais': {
      id: '/_authenticated/_main/mais'
      path: '/mais'
      fullPath: '/mais'
      preLoaderRoute: typeof AuthenticatedMainMaisRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/jornadas': {
      id: '/_authenticated/_main/jornadas'
      path: '/jornadas'
      fullPath: '/jornadas'
      preLoaderRoute: typeof AuthenticatedMainJornadasRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/titulos/': {
      id: '/_authenticated/_main/titulos/'
      path: '/titulos'
      fullPath: '/titulos/'
      preLoaderRoute: typeof AuthenticatedMainTitulosIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/quizzes/': {
      id: '/_authenticated/_main/quizzes/'
      path: '/quizzes'
      fullPath: '/quizzes/'
      preLoaderRoute: typeof AuthenticatedMainQuizzesIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/passe/': {
      id: '/_authenticated/_main/passe/'
      path: '/passe'
      fullPath: '/passe/'
      preLoaderRoute: typeof AuthenticatedMainPasseIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/novidades/': {
      id: '/_authenticated/_main/novidades/'
      path: '/novidades'
      fullPath: '/novidades/'
      preLoaderRoute: typeof AuthenticatedMainNovidadesIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/meus-dados/': {
      id: '/_authenticated/_main/meus-dados/'
      path: '/meus-dados'
      fullPath: '/meus-dados/'
      preLoaderRoute: typeof AuthenticatedMainMeusDadosIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/loja/': {
      id: '/_authenticated/_main/loja/'
      path: '/loja'
      fullPath: '/loja/'
      preLoaderRoute: typeof AuthenticatedMainLojaIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/grupos/': {
      id: '/_authenticated/_main/grupos/'
      path: '/grupos'
      fullPath: '/grupos/'
      preLoaderRoute: typeof AuthenticatedMainGruposIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/central-de-ajuda/': {
      id: '/_authenticated/_main/central-de-ajuda/'
      path: '/central-de-ajuda'
      fullPath: '/central-de-ajuda/'
      preLoaderRoute: typeof AuthenticatedMainCentralDeAjudaIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/campanhas/': {
      id: '/_authenticated/_main/campanhas/'
      path: '/campanhas'
      fullPath: '/campanhas/'
      preLoaderRoute: typeof AuthenticatedMainCampanhasIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/biblioteca/': {
      id: '/_authenticated/_main/biblioteca/'
      path: '/biblioteca'
      fullPath: '/biblioteca/'
      preLoaderRoute: typeof AuthenticatedMainBibliotecaIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/avaliacoes/': {
      id: '/_authenticated/_main/avaliacoes/'
      path: '/avaliacoes'
      fullPath: '/avaliacoes/'
      preLoaderRoute: typeof AuthenticatedMainAvaliacoesIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/amigos/': {
      id: '/_authenticated/_main/amigos/'
      path: '/amigos'
      fullPath: '/amigos/'
      preLoaderRoute: typeof AuthenticatedMainAmigosIndexRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/quizzes/$quizId': {
      id: '/_authenticated/_main/quizzes/$quizId'
      path: '/quizzes/$quizId'
      fullPath: '/quizzes/$quizId'
      preLoaderRoute: typeof AuthenticatedMainQuizzesQuizIdRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/loja/historico': {
      id: '/_authenticated/_main/loja/historico'
      path: '/loja/historico'
      fullPath: '/loja/historico'
      preLoaderRoute: typeof AuthenticatedMainLojaHistoricoRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/grupos/entrar': {
      id: '/_authenticated/_main/grupos/entrar'
      path: '/grupos/entrar'
      fullPath: '/grupos/entrar'
      preLoaderRoute: typeof AuthenticatedMainGruposEntrarRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/dev/botoes': {
      id: '/_authenticated/_main/dev/botoes'
      path: '/dev/botoes'
      fullPath: '/dev/botoes'
      preLoaderRoute: typeof AuthenticatedMainDevBotoesRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/campanhas/ingresso': {
      id: '/_authenticated/_main/campanhas/ingresso'
      path: '/campanhas/ingresso'
      fullPath: '/campanhas/ingresso'
      preLoaderRoute: typeof AuthenticatedMainCampanhasIngressoRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/campanhas/$campaignId': {
      id: '/_authenticated/_main/campanhas/$campaignId'
      path: '/campanhas/$campaignId'
      fullPath: '/campanhas/$campaignId'
      preLoaderRoute: typeof AuthenticatedMainCampanhasCampaignIdRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/avaliacoes/$evaluationId': {
      id: '/_authenticated/_main/avaliacoes/$evaluationId'
      path: '/avaliacoes/$evaluationId'
      fullPath: '/avaliacoes/$evaluationId'
      preLoaderRoute: typeof AuthenticatedMainAvaliacoesEvaluationIdRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
    '/_authenticated/_main/loja/categorias/$categoryId': {
      id: '/_authenticated/_main/loja/categorias/$categoryId'
      path: '/loja/categorias/$categoryId'
      fullPath: '/loja/categorias/$categoryId'
      preLoaderRoute: typeof AuthenticatedMainLojaCategoriasCategoryIdRouteImport
      parentRoute: typeof AuthenticatedMainRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthConfirmationRoute: typeof AuthConfirmationRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthRefreshSessionRoute: typeof AuthRefreshSessionRoute
  AuthResendConfirmationRoute: typeof AuthResendConfirmationRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignOutRoute: typeof AuthSignOutRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthConfirmationRoute: AuthConfirmationRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthRefreshSessionRoute: AuthRefreshSessionRoute,
  AuthResendConfirmationRoute: AuthResendConfirmationRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignOutRoute: AuthSignOutRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedMainRouteRouteChildren {
  AuthenticatedMainJornadasRoute: typeof AuthenticatedMainJornadasRoute
  AuthenticatedMainMaisRoute: typeof AuthenticatedMainMaisRoute
  AuthenticatedMainMissoesRoute: typeof AuthenticatedMainMissoesRoute
  AuthenticatedMainRankingRoute: typeof AuthenticatedMainRankingRoute
  AuthenticatedMainAvaliacoesEvaluationIdRoute: typeof AuthenticatedMainAvaliacoesEvaluationIdRoute
  AuthenticatedMainCampanhasCampaignIdRoute: typeof AuthenticatedMainCampanhasCampaignIdRoute
  AuthenticatedMainCampanhasIngressoRoute: typeof AuthenticatedMainCampanhasIngressoRoute
  AuthenticatedMainDevBotoesRoute: typeof AuthenticatedMainDevBotoesRoute
  AuthenticatedMainGruposEntrarRoute: typeof AuthenticatedMainGruposEntrarRoute
  AuthenticatedMainLojaHistoricoRoute: typeof AuthenticatedMainLojaHistoricoRoute
  AuthenticatedMainQuizzesQuizIdRoute: typeof AuthenticatedMainQuizzesQuizIdRoute
  AuthenticatedMainAmigosIndexRoute: typeof AuthenticatedMainAmigosIndexRoute
  AuthenticatedMainAvaliacoesIndexRoute: typeof AuthenticatedMainAvaliacoesIndexRoute
  AuthenticatedMainBibliotecaIndexRoute: typeof AuthenticatedMainBibliotecaIndexRoute
  AuthenticatedMainCampanhasIndexRoute: typeof AuthenticatedMainCampanhasIndexRoute
  AuthenticatedMainCentralDeAjudaIndexRoute: typeof AuthenticatedMainCentralDeAjudaIndexRoute
  AuthenticatedMainGruposIndexRoute: typeof AuthenticatedMainGruposIndexRoute
  AuthenticatedMainLojaIndexRoute: typeof AuthenticatedMainLojaIndexRoute
  AuthenticatedMainMeusDadosIndexRoute: typeof AuthenticatedMainMeusDadosIndexRoute
  AuthenticatedMainNovidadesIndexRoute: typeof AuthenticatedMainNovidadesIndexRoute
  AuthenticatedMainPasseIndexRoute: typeof AuthenticatedMainPasseIndexRoute
  AuthenticatedMainQuizzesIndexRoute: typeof AuthenticatedMainQuizzesIndexRoute
  AuthenticatedMainTitulosIndexRoute: typeof AuthenticatedMainTitulosIndexRoute
  AuthenticatedMainLojaCategoriasCategoryIdRoute: typeof AuthenticatedMainLojaCategoriasCategoryIdRoute
}

const AuthenticatedMainRouteRouteChildren: AuthenticatedMainRouteRouteChildren =
  {
    AuthenticatedMainJornadasRoute: AuthenticatedMainJornadasRoute,
    AuthenticatedMainMaisRoute: AuthenticatedMainMaisRoute,
    AuthenticatedMainMissoesRoute: AuthenticatedMainMissoesRoute,
    AuthenticatedMainRankingRoute: AuthenticatedMainRankingRoute,
    AuthenticatedMainAvaliacoesEvaluationIdRoute:
      AuthenticatedMainAvaliacoesEvaluationIdRoute,
    AuthenticatedMainCampanhasCampaignIdRoute:
      AuthenticatedMainCampanhasCampaignIdRoute,
    AuthenticatedMainCampanhasIngressoRoute:
      AuthenticatedMainCampanhasIngressoRoute,
    AuthenticatedMainDevBotoesRoute: AuthenticatedMainDevBotoesRoute,
    AuthenticatedMainGruposEntrarRoute: AuthenticatedMainGruposEntrarRoute,
    AuthenticatedMainLojaHistoricoRoute: AuthenticatedMainLojaHistoricoRoute,
    AuthenticatedMainQuizzesQuizIdRoute: AuthenticatedMainQuizzesQuizIdRoute,
    AuthenticatedMainAmigosIndexRoute: AuthenticatedMainAmigosIndexRoute,
    AuthenticatedMainAvaliacoesIndexRoute:
      AuthenticatedMainAvaliacoesIndexRoute,
    AuthenticatedMainBibliotecaIndexRoute:
      AuthenticatedMainBibliotecaIndexRoute,
    AuthenticatedMainCampanhasIndexRoute: AuthenticatedMainCampanhasIndexRoute,
    AuthenticatedMainCentralDeAjudaIndexRoute:
      AuthenticatedMainCentralDeAjudaIndexRoute,
    AuthenticatedMainGruposIndexRoute: AuthenticatedMainGruposIndexRoute,
    AuthenticatedMainLojaIndexRoute: AuthenticatedMainLojaIndexRoute,
    AuthenticatedMainMeusDadosIndexRoute: AuthenticatedMainMeusDadosIndexRoute,
    AuthenticatedMainNovidadesIndexRoute: AuthenticatedMainNovidadesIndexRoute,
    AuthenticatedMainPasseIndexRoute: AuthenticatedMainPasseIndexRoute,
    AuthenticatedMainQuizzesIndexRoute: AuthenticatedMainQuizzesIndexRoute,
    AuthenticatedMainTitulosIndexRoute: AuthenticatedMainTitulosIndexRoute,
    AuthenticatedMainLojaCategoriasCategoryIdRoute:
      AuthenticatedMainLojaCategoriasCategoryIdRoute,
  }

const AuthenticatedMainRouteRouteWithChildren =
  AuthenticatedMainRouteRoute._addFileChildren(
    AuthenticatedMainRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedMainRouteRoute: typeof AuthenticatedMainRouteRouteWithChildren
  AuthenticatedNiveisLevelUidRoute: typeof AuthenticatedNiveisLevelUidRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedMainRouteRoute: AuthenticatedMainRouteRouteWithChildren,
  AuthenticatedNiveisLevelUidRoute: AuthenticatedNiveisLevelUidRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  ManutencaoRoute: ManutencaoRoute,
  PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,
  TermosDeUsoRoute: TermosDeUsoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
